//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import SfProductCardHorizontal from "~/themes/fiskarsMoominDefault/components/components/organisms/SfProductCardHorizontal/SfProductCardHorizontal.vue";
import SfCheckbox from "~/themes/fiskarsMoominDefault/components/components/molecules/SfCheckbox/SfCheckbox.vue";
import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";
import SfProductCard from "~/themes/fiskarsMoominDefault/components/components/organisms/SfProductCard/SfProductCard.vue";
import { useSapcc, useUiNotification, useUiState } from '~/composables';
import { ref } from '@nuxtjs/composition-api';
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import { AnalyticsCartActions } from "~/helpers/analytics/types";
import { adaptProduct } from "~/helpers/analytics/helper";
import { CMSNotificationType } from "~/helpers/extractCMSNotificationMessage";
import { getCMSLabels } from "~/helpers/globalLabels";

export default {
  name: "CartProductsPreview",
  components: {
    SfProductCard,
    SfHeading,
    SfProductCardHorizontal,
    SfCheckbox,
    SfIcon,
  },
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    isSidebar: {
      type: Boolean,
      default: false,
    },
    hideHeading: {
      type: Boolean,
      default: false,
    },
    smallPicture: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
    },
    continueShoppingUrl: {
      type: String,
    },
    removeLabel: {
      type: String,
    },
    exclusiveLabel:{
      type:String,
    },
    badgeLabel:{
      type: String,
    },
    continueShoppingText: {
      type: String,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    quantityText: {
      type: String
    },
    unitPriceText: {
      type: String
    },
    giftWrapText: {
      type: String
    },
    cartsubtitle: {
      type: String,
    },

  },
  setup(props) {
    const { getShoppingCart: loadCart, updateShoppingCart: updateCartItem, removeFromShoppingCart: removeCartItem, applyGiftWrap, removeGiftWrap, error: updateQtyError } = useSapcc('existingCart');
    const cartLoader = ref(false);
    const { send: sendNotification } = useUiNotification();
    const genericError = getCMSLabels('genericerror');
    const {  toggleCountrySelectorModal } = useUiState();



    const updateQty = async data => {
    const { qty, entryNumber, diff, product } = data;
    const numQty = Number(qty);
    if (qty === "" || Number.isNaN(numQty) || numQty < 0 || numQty === product.qty) return;
    
      if(diff !== 0) {
        analyticsEvents.updateCartItem(diff > 0 ? AnalyticsCartActions.ADD : AnalyticsCartActions.REMOVE, adaptProductForEvent(product))
      }

      //add here
      cartLoader.value = true;
      await updateCartItem({qty, entryNumber});
      if (updateQtyError.value) {
        sendNotification({
          type: CMSNotificationType.ERROR,
          message: genericError
        });
      } else {
        await loadCart();
      }

      cartLoader.value = false;
    };

    const removeItem = async (data) => {
      const { entryNumber, product } = data;

      analyticsEvents.updateCartItem(AnalyticsCartActions.REMOVE, adaptProductForEvent(product))

      cartLoader.value = true;
      await removeCartItem({ entryNumber });
      await loadCart();
      cartLoader.value = false;
    };

    const toggleGiftWrap = async (product) => {

      analyticsEvents.giftWrapped(product.wrap ? AnalyticsCartActions.ADD : AnalyticsCartActions.REMOVE, adaptProductForEvent(product))

      if (product.wrap) {
        cartLoader.value = true;
        await applyGiftWrap({ entryNumber: product.itemId });
      } else {
        cartLoader.value = true;
        await removeGiftWrap({ entryNumber: product.itemId });
      }
      await loadCart();
      cartLoader.value = false;
    }

    const adaptProductForEvent = (product) => adaptProduct(product, 'CartProductsPreview')

    const toggleCountrySelector = () => toggleCountrySelectorModal()

    return {
      toggleCountrySelector,
      updateQty,
      removeItem,
      loadCart,
      updateCartItem,
      removeCartItem,
      toggleGiftWrap,
      applyGiftWrap,
      removeGiftWrap,
      cartLoader,
    };
  },
};
